import React, { useEffect, useState } from 'react';
import { analyzeImageTone } from './imageTone';
import s from './AdaptiveLogo.module.sass';

// Обёртка над <img> логотипа: анализирует яркость картинки и, если лого почти
// белый/светлый — подкладывает тёмную подложку, если почти чёрный/тёмный —
// светлую. Для цветных/средних логотипов подложки нет (data-tone="mixed"),
// поэтому на обычных лого визуал не меняется — регрессий нет.
//
// className/style/onError прокидываются на сам <img>, чтобы существующие стили
// и фолбэки путей продолжали работать. Обёртка — inline-flex, чтобы не ломать
// раскладку в шапках и модалках.
export default function AdaptiveLogo({
    src,
    alt = '',
    className,
    style,
    imgStyle,
    onError,
    wrapperClassName,
}) {
    const [tone, setTone] = useState('mixed');

    useEffect(() => {
        let alive = true;
        if (!src) {
            setTone('mixed');
            return undefined;
        }
        analyzeImageTone(src).then((t) => {
            if (alive) setTone(t);
        });
        return () => {
            alive = false;
        };
    }, [src]);

    return (
        <span
            className={`${s.wrap} ${s[tone] || ''} ${wrapperClassName || ''}`}
            style={style}
            data-tone={tone}
        >
            <img
                src={src}
                alt={alt}
                className={className}
                style={imgStyle}
                onError={onError}
            />
        </span>
    );
}
